export const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/forgot-password',
  '/reset-password',
  '/wechat-review',
  '/membership',
  '/benefits',
  '/auto-renewal',
  '/unsubscribe',
  '/pricing',
  '/about',
  '/privacy',
  '/cookie-notice',
  '/refund-policy',
  '/terms',
  '/support',
  '/use-cases',
  '/guides',
  '/blog',
  '/ai-product-photography',
  '/white-background-product-photography',
  '/ai-fashion-model-generator',
  '/ai-clothing-photography',
  '/ai-ecommerce-image-generator',
  '/ai-lookbook-generator',
  '/reference-image-ai-generator',
  '/reference-image-to-ads',
  '/image-to-video-fashion',
  '/ai-video-recreation',
  '/virtual-try-on',
  '/share',
  '/explore',
  '/inspiration',
  '/kagemane',
  '/tools',
  '/t',
  '/join',
  '/coupon',
] as const;

/**
 * Public HTML that is safe to share at the CDN edge.
 *
 * Keep this list intentionally narrower than PUBLIC_ROUTES: login, account,
 * payment, workspace, token and user-generated pages are public from an auth
 * perspective, but must never share their HTML cache across visitors.
 */
export const CACHEABLE_PUBLIC_ROUTES = [
  '/',
  '/about',
  '/pricing',
  '/privacy',
  '/cookie-notice',
  '/refund-policy',
  '/terms',
  '/support',
  '/use-cases',
  '/guides',
  '/ai-product-photography',
  '/white-background-product-photography',
  '/ai-fashion-model-generator',
  '/ai-clothing-photography',
  '/ai-ecommerce-image-generator',
  '/ai-lookbook-generator',
  '/reference-image-ai-generator',
  '/reference-image-to-ads',
  '/image-to-video-fashion',
  '/ai-video-recreation',
  '/virtual-try-on',
] as const;

export const PROTECTED_PREFIXES = ['/p/', '/visual-editor', '/admin'] as const;
export const PROTECTED_EXACT = ['/p'] as const;

export function isPublicRoutePath(pathname?: string | null): boolean {
  if (!pathname) return false;
  return PUBLIC_ROUTES.some((route) => pathname === route || (route !== '/' && pathname.startsWith(`${route}/`)));
}

export function isCacheablePublicRoutePath(pathname?: string | null): boolean {
  if (!pathname) return false;
  return CACHEABLE_PUBLIC_ROUTES.some(
    (route) => pathname === route || (route === '/guides' && pathname.startsWith('/guides/')),
  );
}

export function isProtectedRoutePath(pathname: string): boolean {
  if (PROTECTED_EXACT.includes(pathname as typeof PROTECTED_EXACT[number])) return true;
  return PROTECTED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
